import { useEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import "./styles/globals.css";

import Cursor from "./components/Cursor";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

gsap.registerPlugin(ScrollTrigger);

export default function App() {
  useEffect(() => {
    // GSAP: Navbar fade-in border on scroll
    ScrollTrigger.create({
      start: "80px top",
      onEnter: () => {
        gsap.to("nav", {
          borderBottomColor: "rgba(57,255,20,0.18)",
          duration: 0.4,
        });
      },
      onLeaveBack: () => {
        gsap.to("nav", {
          borderBottomColor: "rgba(30,30,30,0.8)",
          duration: 0.4,
        });
      },
    });

    // Refresh on resize
    window.addEventListener("resize", () => ScrollTrigger.refresh());
    return () => {
      ScrollTrigger.killAll();
    };
  }, []);

  return (
    <>
      <Cursor />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
